import { render, screen, within, waitFor } from '@testing-library/react'
import userEvent from '@testing-library/user-event'

import Activism from './Activism'

function getCardByTitle(title) {
  const heading = screen.getByRole('heading', { name: title })
  return heading.closest('.card')
}

describe('Activism gated download flow', () => {
  beforeEach(() => {
    global.fetch = jest.fn()
    window.open = jest.fn()
  })

  afterEach(() => {
    jest.resetAllMocks()
  })

  test('opens the modal when clicking the menopause campaign document button', async () => {
    render(<Activism />)

    const card = getCardByTitle(/Campaña de solicitud de Atención Sanitaria en Menopausia y Climaterio/i)
    const button = within(card).getByRole('button', { name: /Obtener documento/i })

    await userEvent.click(button)

    expect(screen.getByPlaceholderText(/Introduce tu email para descargarlo/i)).toBeTruthy()
    expect(screen.getByRole('checkbox')).toBeTruthy()
  })

  test('keeps other resources as direct links', () => {
    render(<Activism />)

    const card = getCardByTitle(/Derechos Menstruales en la Ley Orgánica 1\/2023/i)
    const link = within(card).getByRole('link', { name: /Obtener documento/i })

    expect(link.getAttribute('href')).toContain('/pdfs/rights.pdf')
  })

  test('shows a privacy error if the user submits without accepting the privacy policy', async () => {
    render(<Activism />)

    const card = getCardByTitle(/Campaña de solicitud de Atención Sanitaria en Menopausia y Climaterio/i)
    await userEvent.click(within(card).getByRole('button', { name: /Obtener documento/i }))

    await userEvent.type(screen.getByLabelText(/email/i), 'persona@example.com')
    await userEvent.click(screen.getByRole('button', { name: /Descargar documento/i }))

    expect(screen.getByText(/Debes aceptar la política de privacidad/i)).toBeTruthy()
    expect(global.fetch).not.toHaveBeenCalled()
  })

  test('submits the request and opens the pdf after a successful response', async () => {
    global.fetch.mockResolvedValue({
      ok: true,
      json: async () => ({ downloadUrl: '/pdfs/solicitud.pdf' })
    })

    render(<Activism />)

    const card = getCardByTitle(/Campaña de solicitud de Atención Sanitaria en Menopausia y Climaterio/i)
    await userEvent.click(within(card).getByRole('button', { name: /Obtener documento/i }))

    await userEvent.type(screen.getByLabelText(/email/i), 'persona@example.com')
    await userEvent.click(screen.getByRole('checkbox'))
    await userEvent.click(screen.getByRole('button', { name: /Descargar documento/i }))

    await waitFor(() => {
      expect(global.fetch).toHaveBeenCalledWith(
        '/api/document-request',
        expect.objectContaining({
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            email: 'persona@example.com',
            acceptedPrivacy: true,
            documentSlug: 'solicitud-menopausia-climaterio',
            sourcePage: '/'
          })
        })
      )
    })

    await waitFor(() => {
      expect(window.open).toHaveBeenCalledWith('/pdfs/solicitud.pdf', '_blank', 'noopener,noreferrer')
    })
  })

  test('shows an error if the api request fails', async () => {
    global.fetch.mockResolvedValue({
      ok: false,
      json: async () => ({ error: 'No se pudo guardar tu solicitud' })
    })

    render(<Activism />)

    const card = getCardByTitle(/Campaña de solicitud de Atención Sanitaria en Menopausia y Climaterio/i)
    await userEvent.click(within(card).getByRole('button', { name: /Obtener documento/i }))

    await userEvent.type(screen.getByLabelText(/email/i), 'persona@example.com')
    await userEvent.click(screen.getByRole('checkbox'))
    await userEvent.click(screen.getByRole('button', { name: /Descargar documento/i }))

    expect(await screen.findByText(/No se pudo guardar tu solicitud/i)).toBeTruthy()
    expect(window.open).not.toHaveBeenCalled()
  })
})
